import React, {useEffect} from "react";
import "./styles.scss";
import LoginForm from "../components/login-form/LoginForm";
import SidePanel from "../components/side-panal/SidePanel";
import { Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const Login = () => {
  const {push} = useHistory();

  useEffect(() => {
    if (sessionStorage.getItem('isAuthed') === 'true' || localStorage.getItem('isAuthed') === 'true') {
      push("/dashboard/home");
    }
  }, [push]);

  return (
    <Container fluid className="login-wrapper">
      <Row className="h-100">
        <Col className="d-none d-lg-flex p-0" xs={12} lg={4}>
          <SidePanel />
        </Col>
        <Col xs={12} lg={8} className="px-0">
          <LoginForm />
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
